/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetSecondaryPasswordDto } from '../../models/set-secondary-password-dto';

export interface SecureControllerSetSecondaryPassword$Params {
  centerId: string;
      body: SetSecondaryPasswordDto
}

export function secureControllerSetSecondaryPassword(http: HttpClient, rootUrl: string, params: SecureControllerSetSecondaryPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, secureControllerSetSecondaryPassword.PATH, 'post');
  if (params) {
    rb.path('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

secureControllerSetSecondaryPassword.PATH = '/api/secure/center/{centerId}/secondary-password';
